/*
 * Copyright (c) 2022. CodeGen International (Pvt) Ltd. All Rights Reserved.
 *
 * This software is the confidential and proprietary information of CodeGen
 * International (Pvt) Ltd. ("Confidential Information"). You shall not disclose
 * such Confidential Information and shall use it only in accordance with the
 * terms of the license agreement you entered into with CodeGen International.
 *
 */

import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {TCO} from '../../../../constants';
import {ConfigLoader} from '@tc-core/util/framework';
import {SetupGridComp} from '../../../../widgets/framework/ag-grid-custom-components/components/setup-grid/setup-grid-comp';
import {JobService} from '../../../../services/backend-consumers/job/job-service';
import {JobParameterSearchCriteria} from '../../../../models/criteria/job-parameter-search-criteria';
import {tap} from 'rxjs/operators';
import {DataKey, DataStoreService} from '../../../../services/util/framework/data-store.service';
import {SetupGridDataSource} from '../../../../widgets/framework/ag-grid-custom-components/components/setup-grid/setup-grid-data-source';
import {Observable, of} from 'rxjs';
import {IGetRowsParams} from 'ag-grid-community';

/**
 * @author lakshan
 * @since 08 Nov, 2022
 */

@Component({
    selector: 'tc-job-parameter-focus-view',
    templateUrl: './job-parameter-focus-view.component.html'
})
export class JobParameterFocusViewComponent extends SetupGridComp implements OnInit, SetupGridDataSource {

    @ViewChild('setupGrid')
    pageSize = 20;
    searchPage = 0;
    sortBy = 'id';
    sortDirection = 'ASC';

    @Input() data: any;

    public colDefConfig = [];
    public jobParameterSearchCriteria = new JobParameterSearchCriteria();


    constructor(
        private configLoader: ConfigLoader,
        private jobService: JobService,
        private dataStoreService: DataStoreService
    ) {
        super();
    }

    ngOnInit() {
        // Load Job Parameter grid configs
        this.colDefConfig = this.configLoader.configurations.get(TCO.CONF.CONF_JOB_PARAMETER_GRID);
    }

    createNewRow(): any {
        return {unsaved: true};
    }

    isInvalidRow(params): boolean {
        return false;
    }

    isUnsavedRow(row: any): boolean {
        return false;
    }

    deleteRow(row: any): Observable<any> {
        if (row && row.id) {
            return this.jobService.deleteJobParameter(row.id);
        } else {
            return of('success');
        }
    }

    getRows(params: IGetRowsParams): Observable<any> {
        if (this.data && this.data.jobName) {
            this.jobParameterSearchCriteria.jobName = this.data.jobName;
        }
        return this.jobService.getJobParameter(this.jobParameterSearchCriteria).pipe(
            tap(data =>
                this.dataStoreService.set(DataKey.jobParameterSearchResults, data)
            )
        );
    }

    saveRow(row: any, event: any): Observable<any> {
        if (this.data) {
            row.jobName = this.data.jobName;
        }
        return this.jobService.addJobParameter(row);
    }

}
